import axios from "axios";
const convertAreaToRaiNganWah = (areaInM2) => {
    const area = Math.floor(areaInM2); // ตัดเศษทิ้ง
  
    const rai = Math.floor(area / 1600);
    const remainingAfterRai = area % 1600;
  
    const ngan = Math.floor(remainingAfterRai / 400);
    const remainingAfterNgan = remainingAfterRai % 400;
  
    const wah = Math.floor(remainingAfterNgan / 4);
  
    return {
      rai,
      ngan,
      wah,
    };
  };
const CreateLand = async (payload) => {
    const userData = JSON.parse(localStorage.getItem("userdata"));
    const timestamp = Math.floor(Date.now() / 1000);
    const areaConverted = convertAreaToRaiNganWah(parseFloat(payload.area));
    const latArray = payload.point.map((p) => p.lat);
    const lonArray = payload.point.map((p) => p.long);
    let payload_out = {
        "appFarmerId": userData.appFarmerId,
        "appLandId": "LD" + timestamp,
        "landType": payload.landType,
        "lat": latArray,
        "lon": lonArray,
        "latDegrees": 13,
        "latMinutes": 52,
        "latSeconds": 37.38,
        "latDirection": "N",
        "lonDegrees": 100,
        "lonMinutes": 24,
        "lonSeconds": 40.98,
        "lonDirection": "E",
        "kml": "Google Map KML",
        "noOfRais": areaConverted.rai,
        "noOfNgan": areaConverted.ngan,
        "noOfWah": areaConverted.wah,
    }
    const token = JSON.parse(localStorage.getItem("authentication"));
    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };

    try {
        const { data } = await axios.post(
            `${process.env.REACT_APP_BACKEND_API}/api/land/CreateLand`,
            payload_out,
            config
        );
        return { status: 200, payload: data };
    } catch (error) {
        console.error("CreateFarm error:", error);

        const status = error?.response?.status || 500;
        return { status, payload: null };
    }
};

export default CreateLand;
